import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "zoom-out_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21 3v2h-8V3h8Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3 10.5a7.5 7.5 0 0 1 7-7.484v2.006a5.5 5.5 0 1 0 5.4 2.977h2.173c.277.782.427 1.624.427 2.5 0 1.71-.573 3.288-1.537 4.55L21 19.584 19.585 21l-4.536-4.536A7.5 7.5 0 0 1 3 10.5Z"
    }, null, -1)
  ]))]))
}
export default { render: render }